import { Injectable } from "@angular/core";
import { LoggingService } from "@merri/common";
import { PRODUCT_NAME, SeoService } from "src/app/core";

export interface ProductPlan {
  title: string;
  price: number;
  action: string;
  description: string;
  features: string[];
  tier: number;
}

@Injectable({
  providedIn: "root",
})
export class PlanChooserService {
  private defaultPlan: ProductPlan;
  private plans: ProductPlan[];

  constructor(private seoService: SeoService) {
    LoggingService.log("PlanChooserService ctor");

    this.plans = [
      {
        title: "Do It Myself",
        price: 99,
        tier: 1,
        action: "GET STARTED",
        description: `Unleash your inner event planner using the ${PRODUCT_NAME} visualization platform and suite of planning tools`,
        features: [
          "Interactive 3D design tool",
          `${PRODUCT_NAME} inspiration board & planning tools`,
          "Vendor marketplace",
          "24/7 customer service",
        ],
      },
      {
        title: "Do It For Me",
        price: 399,
        tier: 2,
        action: "GET STARTED",
        description:
          "Get matched with a professional event planner who helps bring your vision to life, supporting you through the process whenever, wherever",
        features: [
          "Interactive 3D design tool",
          `${PRODUCT_NAME} inspiration board & planning tools`,
          "Vendor marketplace",
          "A dedicated event planner by your side every step of the way (virtually, that is) – from defining your vision, to booking vendors, and tackling that dreadful seating chart",
        ],
      },
    ];

    this.defaultPlan = this.plans[this.plans.length - 1];
  }

  getDefaultPlan(): ProductPlan {
    return this.defaultPlan;
  }

  getPlanByUrl(planNameFromUrl: string): ProductPlan {
    return this.plans.find(i => this.seoService.normalizeForUrl(i.title.toLowerCase()) === planNameFromUrl.toLowerCase());
  }

  getProductPlans(): ProductPlan[] {
    return this.plans;
  }
}
